import request from '@/utils/request'

let Search_logApi = {

  /*搜索记录列表*/
  list(data) {
    return request._post('/shop/plus.search_log.Index/index', data);
},
/*添加搜索记录*/
add(data) {
    return request._post('/shop/plus.search_log.Index/add', data);
},
/*修改搜索记录*/
edit(data) {
    return request._post('/shop/plus.search_log.Index/edit', data);
},
/*删除搜索记录*/
del(data) {
    return request._post('/shop/plus.search_log.Index/del', data);
},
/*搜索记录详情*/
detail(data) {
  return request._post('/shop/plus.search_log.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.search_log.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.search_log.Setting/getSetting', data, errorback);
    },
}
export default Search_logApi;



// WEBPACK FOOTER //
// ./src/api/search_log.js